import { LandingPageDefault } from 'src/components/features';

const LandingPage = () => <LandingPageDefault />;

export default LandingPage;
